export const expenseColorsWeek = {
  approvalPending: "bg-gray-400 ",
  approvalRefused: "bg-purple-400",
  managerApproval: "bg-green-400",
  approvalRejected: "bg-red-600",
  accountantApproval: "bg-blue-500",
  amountDue: "bg-yellow-300"
};

export const summaryApprovalItems = [
  {
    count: 0,
    icon: "/img/timer.png",
    approvalState: "approvalPending",
    label: "en attente",
    style: `${expenseColorsWeek["approvalPending"]}`,
    inStyle: { maxWidth: "60%" },
    textColor: "text-gray-400"
  },
  {
    count: 0,
    icon: "/img/close.png",
    approvalState: "amountDue",
    label: "remboursées",
    style: `${expenseColorsWeek["amountDue"]}`,
    inStyle: {},
    textColor: "text-yellow-300"
  },
  {
    count: 0,
    icon: "/img/close.png",
    approvalState: "approvalRejected",
    label: "rejetées",
    style: `${expenseColorsWeek["approvalRejected"]}`,
    inStyle: { maxWidth: "60%" },
    textColor: "text-red-600"
  },
  {
    count: 0,
    icon: "/img/check.png",
    approvalState: "managerApproval",
    label: "acceptées",
    style: `${expenseColorsWeek["managerApproval"]}`,
    inStyle: { maxWidth: "60%" },
    textColor: "text-green-400"
  },
  {
    count: 0,
    icon: "/img/close.png",
    approvalState: "approvalRefused",
    label: "refusées",
    style: `${expenseColorsWeek["approvalRefused"]}`,
    inStyle: {},
    textColor: "text-purple-600"
  },
  {
    count: 0,
    icon: "/img/check.png",
    approvalState: "accountantApproval",
    label: "validées",
    style: `${expenseColorsWeek["accountantApproval"]}`,
    inStyle: { maxWidth: "60%" },
    textColor: "text-blue-500"
  }
];

export const expenseReportsDetails = {
  1: {
    icon: "/img/timer.png",
    style: `${expenseColorsWeek["approvalPending"]}`
  },
  2: {
    icon: "/img/check.png",
    style: `${expenseColorsWeek["managerApproval"]}`
  },
  3: {
    icon: "/img/check.png",
    style: `${expenseColorsWeek["accountantApproval"]}`
  },
  4: {
    icon: "/img/close.png",
    style: `${expenseColorsWeek["approvalRefused"]}`
  },
  5: {
    icon: "/img/close.png",
    style: `${expenseColorsWeek["amountDue"]}`
  }
};



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/ExpenseReportsWeekly.utils.js